import { graphql, readInlineData } from "react-relay";

import { checkIsMorningStudioArticle } from "~/components/article/article-render/morning-studio-article/helpers";
import { checkIsPhotoEssayArticle } from "~/components/article/article-render/photo-essay-article/helpers";
import type { helpersAppBarThemeArticle$key } from "~/queries/__generated__/helpersAppBarThemeArticle.graphql";

export type AppBarTheme = "light" | "dark";

export const getAppBarTheme = (reference: helpersAppBarThemeArticle$key): AppBarTheme => {
  const article = readInlineData(
    graphql`
      fragment helpersAppBarThemeArticle on Article @inline {
        sponsorType
        articleTypes: types {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );
  const articleTypes =
    article.articleTypes?.flatMap(
      types => types?.value?.map(value => value?.entityId ?? "") ?? [],
    ) ?? [];

  if (
    checkIsMorningStudioArticle(article.sponsorType, articleTypes) ||
    checkIsPhotoEssayArticle(articleTypes)
  ) {
    return "dark";
  }

  return "light";
};
